import { render } from "./EditSerialNumber.vue?vue&type=template&id=447c8643"
import script from "./EditSerialNumber.vue?vue&type=script&lang=js"
export * from "./EditSerialNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__